require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-disability-ida-19-crosscutting-theme.json") })
        }
      }, "path---en-us-update-disability-ida-19-crosscutting-theme");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-disability-ida-19-crosscutting-theme!./.cache/json/en-us-update-disability-ida-19-crosscutting-theme.json
// module id = 654
// module chunks = 231608221292675